var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	"webpack/sharing/consume/default/jquery/jquery": () => (loadSingletonVersion("default", "jquery", true, [1,3,7,1], () => (() => (__webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js"))))),
	"webpack/sharing/consume/default/underscore/underscore": () => (loadSingletonVersion("default", "underscore", false, [1,1,13,7], () => (__webpack_require__.e("vendors-node_modules_underscore_modules_index-all_js").then(() => (() => (__webpack_require__(/*! underscore */ "./node_modules/underscore/modules/index-all.js"))))))),
	"webpack/sharing/consume/default/@plone/registry/@plone/registry": () => (loadSingletonVersion("default", "@plone/registry", false, [1,2,5,4], () => (__webpack_require__.e("vendors-node_modules_plone_registry_dist_index_js").then(() => (() => (__webpack_require__(/*! @plone/registry */ "./node_modules/@plone/registry/dist/index.js"))))))),
	"webpack/sharing/consume/default/jquery-form/jquery-form": () => (loadSingletonVersion("default", "jquery-form", false, [4,4,3,0], () => (__webpack_require__.e("vendors-node_modules_jquery-form_dist_jquery_form_min_js").then(() => (() => (__webpack_require__(/*! jquery-form */ "./node_modules/jquery-form/dist/jquery.form.min.js"))))))),
	"webpack/sharing/consume/default/js-cookie/js-cookie": () => (loadSingletonVersion("default", "js-cookie", false, [1,3,0,5], () => (__webpack_require__.e("node_modules_js-cookie_dist_js_cookie_mjs").then(() => (() => (__webpack_require__(/*! js-cookie */ "./node_modules/js-cookie/dist/js.cookie.mjs"))))))),
	"webpack/sharing/consume/default/bootstrap/bootstrap": () => (loadSingletonVersion("default", "bootstrap", true, [4,5,3,8], () => (() => (__webpack_require__(/*! bootstrap */ "./node_modules/bootstrap/dist/js/bootstrap.esm.js"))))),
	"webpack/sharing/consume/default/backbone/backbone?c588": () => (loadSingletonVersion("default", "backbone", false, [4,1,6,0], () => (Promise.all([__webpack_require__.e("vendors-node_modules_backbone_backbone_js"), __webpack_require__.e("webpack_sharing_consume_default_jquery_jquery")]).then(() => (() => (__webpack_require__(/*! backbone */ "./node_modules/backbone/backbone.js"))))))),
	"webpack/sharing/consume/default/moment/moment": () => (loadSingletonVersion("default", "moment", false, [1,2,30,1], () => (__webpack_require__.e("vendors-node_modules_moment_moment_js").then(() => (() => (__webpack_require__(/*! moment */ "./node_modules/moment/moment.js"))))))),
	"webpack/sharing/consume/default/dropzone/dropzone?b63a": () => (loadSingletonVersion("default", "dropzone", false, [4,5,9,3], () => (__webpack_require__.e("vendors-node_modules_dropzone_dist_dropzone_js").then(() => (() => (__webpack_require__(/*! dropzone */ "./node_modules/dropzone/dist/dropzone.js"))))))),
	"webpack/sharing/consume/default/pikaday/pikaday": () => (loadSingletonVersion("default", "pikaday", false, [1,1,8,0], () => (Promise.all([__webpack_require__.e("vendors-node_modules_pikaday_pikaday_js"), __webpack_require__.e("webpack_sharing_consume_default_moment_moment")]).then(() => (() => (__webpack_require__(/*! pikaday */ "./node_modules/pikaday/pikaday.js"))))))),
	"webpack/sharing/consume/default/tippy.js/tippy.js": () => (loadSingletonVersion("default", "tippy.js", false, [1,6,3,7], () => (__webpack_require__.e("vendors-node_modules_tippy_js_dist_tippy_esm_js").then(() => (() => (__webpack_require__(/*! tippy.js */ "./node_modules/tippy.js/dist/tippy.esm.js"))))))),
	"webpack/sharing/consume/default/sortablejs/sortablejs": () => (loadSingletonVersion("default", "sortablejs", false, [1,1,15,6], () => (__webpack_require__.e("vendors-node_modules_sortablejs_modular_sortable_esm_js").then(() => (() => (__webpack_require__(/*! sortablejs */ "./node_modules/sortablejs/modular/sortable.esm.js"))))))),
	"webpack/sharing/consume/default/backbone/backbone?1166": () => (loadSingletonVersion("default", "backbone", false, [4,1,6,0], () => (__webpack_require__.e("vendors-node_modules_plone_mockup_node_modules_backbone_backbone_js").then(() => (() => (__webpack_require__(/*! backbone */ "./node_modules/@plone/mockup/node_modules/backbone/backbone.js"))))))),
	"webpack/sharing/consume/default/backbone.paginator/backbone.paginator": () => (loadSingletonVersion("default", "backbone.paginator", false, [4,2,0,8], () => (__webpack_require__.e("vendors-node_modules_backbone_paginator_lib_backbone_paginator_js").then(() => (() => (__webpack_require__(/*! backbone.paginator */ "./node_modules/backbone.paginator/lib/backbone.paginator.js"))))))),
	"webpack/sharing/consume/default/select2/select2": () => (loadSingletonVersion("default", "select2", false, [4,3,5,4], () => (__webpack_require__.e("select2").then(() => (() => (__webpack_require__(/*! select2 */ "./node_modules/select2/select2.js"))))))),
	"webpack/sharing/consume/default/jqtree/jqtree": () => (loadSingletonVersion("default", "jqtree", false, [4,1,8,10], () => (__webpack_require__.e("vendors-node_modules_jqtree_tree_jquery_js").then(() => (() => (__webpack_require__(/*! jqtree */ "./node_modules/jqtree/tree.jquery.js"))))))),
	"webpack/sharing/consume/default/dropzone/dropzone?9f55": () => (loadSingletonVersion("default", "dropzone", false, [4,5,9,3], () => (__webpack_require__.e("vendors-node_modules_plone_mockup_node_modules_dropzone_dist_dropzone_mjs").then(() => (() => (__webpack_require__(/*! dropzone */ "./node_modules/@plone/mockup/node_modules/dropzone/dist/dropzone.mjs")))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"webpack_sharing_consume_default_jquery_jquery": [
		"webpack/sharing/consume/default/jquery/jquery"
	],
	"webpack_sharing_consume_default_underscore_underscore": [
		"webpack/sharing/consume/default/underscore/underscore"
	],
	"node_modules_plone_mockup_node_modules_bootstrap-icons_icons_node_modules_bootstrap-icons_ico-68ddcd": [
		"webpack/sharing/consume/default/@plone/registry/@plone/registry",
		"webpack/sharing/consume/default/jquery-form/jquery-form",
		"webpack/sharing/consume/default/js-cookie/js-cookie"
	],
	"webpack_sharing_consume_default_bootstrap_bootstrap": [
		"webpack/sharing/consume/default/bootstrap/bootstrap"
	],
	"webpack_sharing_consume_default_backbone_backbone": [
		"webpack/sharing/consume/default/backbone/backbone?c588"
	],
	"webpack_sharing_consume_default_moment_moment": [
		"webpack/sharing/consume/default/moment/moment"
	],
	"webpack_sharing_consume_default_dropzone_dropzone-_b63a": [
		"webpack/sharing/consume/default/dropzone/dropzone?b63a"
	],
	"webpack_sharing_consume_default_pikaday_pikaday": [
		"webpack/sharing/consume/default/pikaday/pikaday"
	],
	"webpack_sharing_consume_default_tippy_js_tippy_js": [
		"webpack/sharing/consume/default/tippy.js/tippy.js"
	],
	"webpack_sharing_consume_default_sortablejs_sortablejs": [
		"webpack/sharing/consume/default/sortablejs/sortablejs"
	],
	"resources_pat_structure_js_views_app_js-webpack_sharing_consume_default_backbone_backbone": [
		"webpack/sharing/consume/default/backbone/backbone?1166",
		"webpack/sharing/consume/default/backbone.paginator/backbone.paginator"
	],
	"webpack_sharing_consume_default_select2_select2": [
		"webpack/sharing/consume/default/select2/select2"
	],
	"webpack_sharing_consume_default_jqtree_jqtree": [
		"webpack/sharing/consume/default/jqtree/jqtree"
	],
	"webpack_sharing_consume_default_dropzone_dropzone-_9f55": [
		"webpack/sharing/consume/default/dropzone/dropzone?9f55"
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}